module.exports = {
    'selectLanguage': 'Choisissez votre language',
    'articleFilter': 'Filtrez les articles:',
    'albumFilter': 'Filtrez les albums:',
    'contactUs': 'Contactez-Nous',
    'openingHours': 'Heures d\'ouverture',
    'submitButton': 'Envoyer',
    'formName': 'Votre nom',
    'formEmail': 'Votre courriel',
    'formMessage': 'Votre message',
    'instagramHeader': 'Suivez-Nous sur Instagram @centremultisport',
    'socialHeader': 'Suivez-Nous sur Facebook/Instagram',
    'pageNext': 'Page suivante',
    'pagePrevious': 'Page precedente',
    'partners': 'Nos partenaires',
    'comingSoon': 'A venir',
    'weekdays': 'Lundi au vendredi',
    'weekends': 'Samedi et dimanche',
    'office': 'Bureau',
    'field': 'Terrain',
    'ifRequired': 'au besoin',
    'moreNews': 'Plus de nouvelles',
    'backToNews': 'Retour aux nouvelles',
    'all': 'Tous'
  };